import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import { IndosbookMascot } from "./IndosbookLogo";
import { footerLegalLinks, footerColumns } from "../mock";
import Hero from "./landing/Hero";
import StatsStrip from "./landing/StatsStrip";
import FeaturesBento from "./landing/FeaturesBento";
import { Testimonials, CtaBanner } from "./landing/Testimonials";
import { BackToTop } from "./BackToTop";
import { usePageMeta, HOME_META } from "../lib/seo";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="border-t border-gray-100 bg-white/80">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-y-8 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <IndosbookMascot size={28} />
              <span className="font-heading text-xl font-extrabold text-[#0B2D8C]">indosbook</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-gray-500">
              The social platform for seafarers,<br />
              shipping companies and maritime institutes.
            </p>
            <div className="mt-5">
              <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400">Coming soon on mobile</p>
              <div className="mt-2 flex items-center gap-2.5">
                <img src="/badge-google-play.svg" alt="Get it on Google Play — coming soon" className="h-9 w-auto opacity-90 transition-opacity hover:opacity-100" />
                <img src="/badge-app-store.svg" alt="Download on the App Store — coming soon" className="h-9 w-auto opacity-90 transition-opacity hover:opacity-100" />
              </div>
            </div>
          </div>
          <div className="md:col-span-8">
            <div className="grid grid-cols-2 gap-x-5 gap-y-8 sm:grid-cols-3 lg:grid-cols-5 md:pl-4">
              {footerColumns.map((col) => (
                <div key={col.h}>
                  <div className="text-sm font-bold text-gray-800">{col.h}</div>
                  <ul className="mt-2.5 space-y-2">
                    {col.items.map((i) => (
                      <li key={i.label}>
                        <button onClick={() => navigate(i.to)} className="text-left text-sm text-gray-500 transition-colors hover:text-[#FF4500]">{i.label}</button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-col items-center gap-4 border-t border-gray-200 pt-6">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {footerLegalLinks.map((l) => (
              <button key={l.to} onClick={() => navigate(l.to)} className="text-xs font-semibold text-gray-400 transition-colors hover:text-[#FF4500]">{l.label}</button>
            ))}
          </div>
          <p className="text-center text-sm text-gray-400">© 2026 <span className="font-bold text-gray-500">Indosbook</span>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

const LandingPage = () => {
  usePageMeta(HOME_META);
  // always start the landing page at the very top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="top" className="min-h-screen bg-white text-[#1a1a1b] antialiased">
      <BackToTop />
      <Header />
      <Hero />
      <StatsStrip />
      <FeaturesBento />
      <Testimonials />
      <CtaBanner />
      <Footer />
    </div>
  );
};

export default LandingPage;
